//Generated File 
export const AnotherField = `AnotherField`;
export const Avg = `Avg`;
export const Max = `Max`;
export const Min = `Min`;
export const Value = `Value`;
